import axios from 'axios';

const loadAbort = () => {
    return new AbortController();
};

export const getPlacesDetailsEndpoint = (
    input: string,
    sid: string | null,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/search/places-details`,
                data: JSON.stringify({ input, sid }),
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        controller,
    };
};
